/* see docs/EXTRACTED_COMMENTS.md#c060 */

import {
  InlineClassPicker,
  type PickerEntry,
  type PickerVariant,
} from "./InlineClassPicker"
import type { API } from "@editorjs/editorjs"

export class FontSizeTool extends InlineClassPicker {
  static title = "Font size"

  private sizes: number[]

  constructor({
    api,
    config,
  }: {
    api: API
    config?: { sizes?: number[] }
  }) {
    super({ api })
    this.sizes = config?.sizes ?? []
  }

  protected get pickerTitle(): string {
    return "Font size"
  }

  protected get variant(): PickerVariant {
    return "chips"
  }

  protected get icon(): string {
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <text x="3" y="18" font-family="Georgia, 'Times New Roman', serif"
        font-size="17" font-weight="700" fill="currentColor">A</text>
      <text x="14.5" y="18" font-family="Georgia, 'Times New Roman', serif"
        font-size="10" font-weight="600" fill="currentColor">A</text>
    </svg>`
  }

  protected get entries(): PickerEntry[] {
    return this.sizes.map(size => ({
      label: `${size}`,
      className: "",
      style: { fontSize: `${size}pt` },
    }))
  }
}
